/**
 * Created by zhengyf 2017/9/5
 */

subAccountDetailCtrl.$inject = ['$scope', '$http', '$q', 'request'];
angular.module('DSSXAPP', ['app.core']);

angular
    .module('DSSXAPP')
    .controller('subAccountDetailCtrl', subAccountDetailCtrl);

function subAccountDetailCtrl($scope, $http, $q, request) {

    var vm = $scope;

    vm.userInfo = {};
    var url = window.location.href;
    var index = url.indexOf('?');
    vm.accountId = url.slice(index + 1).split('=')[1];

    vm.c = {
        unableGetAccountInfo: false,
        unableGetAccountInfoErrReason: '',
    };

    init();

    function init() {
        console.log('[sub account detail init: ]');
        getAccountInfo();
    }

    function getAccountInfo() {
        var sendUrl = '/usr/api/loadSubAccount?accountId=' + vm.accountId;
        request.get(sendUrl, {}, false)
            .then(success, error);

        function success(res) {
            res = res || {};
            vm.userInfo = res.data.subAccount;
            vm.name = vm.userInfo.name.firstName + ' ' + vm.userInfo.name.lastName;
            if (!vm.userInfo.fax || !vm.userInfo.fax.areaCode) {
                vm.fax = '';
            } else {
                vm.fax = vm.userInfo.fax.countryCode + ' ' + vm.userInfo.fax.areaCode + ' ' + vm.userInfo.fax.phoneNumber;
            }

            vm.userInfo.tel = vm.userInfo.tel || {};
            vm.tel = (vm.userInfo.tel.countryCode || '') + ' ' + (vm.userInfo.tel.areaCode || '') + ' ' + (vm.userInfo.tel.phoneNumber || '');
            vm.userInfo.contactAddress = vm.userInfo.contactAddress || {};
            vm.address = (vm.userInfo.contactAddress.country || '') + ' ' + (vm.userInfo.contactAddress.province || '') + ' ' + (vm.userInfo.contactAddress.city || '');
        }

        function error(err) {
            var code = DSSX.util.safe(err, 'data.data.code', '-1');

            if (3 === code) {
                vm.c.unableGetAccountInfo = true
                vm.c.unableGetAccountInfoErrReason = DSSX.util.safe(err, 'data.data.dmsg', '')
                return
            }

            DSSX.dialog.err(err, {
                moduleName: '管理子账号',
                funcName: 'getAccountInfo',
                text: '获取子账号信息失败'
            });
        }
    }


}
